const NumberUtil = {
  /** 정수형 변환 */
  restrictInt(value: number) {
    const formatted = parseInt(String(value).replace(/\D/g, ""));
    return isNaN(formatted) ? 0 : formatted;
  },

  /** 스페이스바 입력 방지 */
  preventSpace(event: KeyboardEvent) {
    if (event.key === " ") {
      event.preventDefault();
    }
  },

  onlyNumber(event: KeyboardEvent) {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Home",
      "End",
    ];

    // 숫자 키(0~9)만 허용, 편집키/단축키는 허용
    if (
      !/^\d$/.test(event.key) && // 숫자가 아니고
      !allowedKeys.includes(event.key) &&
      !(event.ctrlKey || event.metaKey) // 단축키는 허용
    ) {
      event.preventDefault();
    }
  },
};

export default {
  ...NumberUtil,
};
